<template>
    <div>
        <div style="width: 100%; position: relative;">
            <van-image width="100%" height="108px" fit="cover" :src="require('@/assets/shareBackground.jpg')"/>
            <div style="color: white; text-align: center; position: absolute; top: 26px; left: 0; right: 0;">
                <div style="font-size: 32px; min-height: 44px;">{{integral}}</div>
                <div style="font-size: 14px;">当前积分</div>
            </div>
            <div style=" margin-top: 10px;">
                <div style="background-color: white; padding: 8px 20px;">积分明细</div>
                <van-list>
                    <div style="display: flex; color: #333333; font-size: 12px;  background-color: white;  padding: 10px 0 10px 20px; margin-top: 1px;">
                        <div style="flex: 3;">时间</div>
                        <div style="flex: 2;">姓名</div>
                        <div style="flex: 2;">类别</div>
                        <div style="flex: 2;">积分</div>
                    </div>
                    <div v-for="(item,index) in list" :key="index" style="display: flex; color: #333333; font-size: 12px;  background-color: white;  padding: 10px 0 10px 20px; margin-top: 1px;">
                        <div style="flex: 3;">{{item.shareDate|dateFormat('YYYY-MM-DD')}}</div>
                        <div style="flex: 2;">{{item.userName}}</div>
                        <div style="flex: 2;">{{item.shareType === 1 ? '注册' : '购买'}}</div>
                        <div style="flex: 2;">{{item.shareIntegral}}</div>
                    </div>
                    <div @click="showMore" style="color: #3173C8; font-size: 12px; text-align: center; background-color: white;margin-top: 1px; padding: 10px 0;">查看更多</div>
                </van-list>
            </div>
            <div style=" margin-top: 10px;">
                <div style="background-color: white; padding: 8px 20px;">积分规则</div>
                <div v-if="role() === '1'" style="color: #666666; font-size: 12px; padding: 10px 20px; margin-top: 1px; background-color: white;">
                    分销员: <br/>邀请客户注册成功，+1积分；<br/> 本人购买保险成功，按照支付金额的5%换算积分； 邀请的客户购买保险成功，按照支付金额的8%换算积分；
                    <br/>备注：分销员的积分，我们将通过线下的方式转换为现金发放。
                </div>
                <div v-else style="color: #666666; font-size: 12px; padding: 10px 20px; margin-top: 1px; background-color: white;">
                    普通用户<br/>邀请其它用户注册成功，+1积分；<br/>购买保险成功，按照支付金额的5%换算积分；<br/>备注：普通用户的积分，将来可以在平台换购相关产品。<br/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button, Cell, List} from 'vant';

    Vue.use(Image).use(Button).use(Cell).use(List);


    export default {
        name: "Integral",
        data() {
            return {
                integral: '',
                user: this.$store.state.user.user,
                list: [],
                page: 0,
                pageSize: 10,
            }
        },
        created() {
            this.$axios.get("/user/info").then(res => {
                if (res.code == 200) {
                    this.integral = res.data.shareIntegral
                }
            })
            this.$axios.get("/integral//list",{params: {page: this.page, limit: this.pageSize}}).then(res => {
                if (res.code == 200 && res.data.rows) {
                    this.list = res.data.rows
                }
            }).catch(err => {
                console.log(err);
            })
        },
        methods: {
            role() {
                return this.$store.state.user.role ? this.$store.state.user.role : '0'
            },
            showMore() {
                this.$router.push('/integralDetail')
            }
        }
    }
</script>

<style scoped>

</style>
